import { combineReducers } from 'redux';

import adminSerffPlansLoadStatus from './serff/adminSerffPlansLoadStatus';
import adminSerffTransferStatus from './serff/adminSerffTransferStatus';
import adminSerffIsserList from './serff/adminSerffIsserList';

export default combineReducers({
    adminSerffPlansLoadStatus,
    adminSerffTransferStatus,
    adminSerffIsserList
});
